function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import { cx, runIfFn, __DEV__ } from '../../utils';
import { tqc, forwardRef, omitThemingProps, StylesProvider, useMultiStyleConfig, useStyles } from '../../system';
import { MenuProvider, useMenu, useMenuContext, useMenuList } from './useMenu';
import { ScaleFade } from '../transition';

/**
 * ContentMenu provides context, state, and focus management
 * to its sub-components. It doesn't render any DOM node.
 */
export var ContentMenu = props => {
  var {
    children,
    isOpen: isOpenProp = true
  } = props;
  var styles = useMultiStyleConfig('ContentMenu', props);
  var ownProps = omitThemingProps(props);
  var ctx = useMenu(_objectSpread(_objectSpread({}, ownProps), {}, {
    isOpen: isOpenProp
  }));
  var context = React.useMemo(() => ctx, [ctx]);
  var {
    isOpen,
    onClose,
    forceUpdate
  } = context;
  return /*#__PURE__*/React.createElement(MenuProvider, {
    value: context
  }, /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, runIfFn(children, {
    isOpen,
    onClose,
    forceUpdate
  })));
};
if (__DEV__) {
  ContentMenu.displayName = 'ContentMenu';
}
export var ContentMenuList = forwardRef((props, ref) => {
  var _props$zIndex, _styles$list;
  var rest = _extends({}, props);
  var {
    isOpen
  } = useMenuContext();
  var listProps = useMenuList(rest, ref);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.div, {
    __css: {
      zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : (_styles$list = styles.list) === null || _styles$list === void 0 ? void 0 : _styles$list.zIndex
    }
  }, /*#__PURE__*/React.createElement(ScaleFade, _extends({}, listProps, {
    className: cx('tqc-menu__menu-list', listProps.className),
    in: isOpen,
    __css: _objectSpread({
      outline: 0
    }, styles.list)
  })));
});
if (__DEV__) {
  ContentMenuList.displayName = 'ContentMenuList';
}
export var SubMenu = props => {
  var {
    indent = 5,
    children
  } = props;
  return /*#__PURE__*/React.createElement(tqc.div, {
    __css: {
      paddingLeft: indent
    }
  }, children);
};
if (__DEV__) {
  SubMenu.displayName = 'SubMenu';
}